<template>
  <div id="app">
    <router-view />
    <Alerta />
    <Spinner />
  </div>
</template>

<script>
export default {
  name: "App",

  created: function () {
    // eslint-disable-next-line
    console.log("App created");
    this.$store.dispatch("setupMediaQueries");
    this.$store.dispatch("getPortfolio");
    this.$store.dispatch("getUrlClubMMT");
  },
};
</script>

<style lang="scss">
/*
colores web corporativa
turquesa, barra menu: 2a89b3, letras en blanco
circulos azul claro: 40a6e1, letras en blanco
cuadro grande que resalta: 303f58, letras en blanco
verde que resalta, solo en un boton: 27a000, letras en blanco
naranja complementario: dc7000, letras en blanco
azul celeste, solo en barra superior: c7e7f6, letras en negro
azul mmt, banner principal: 1e4ea2, letras en blanco
*/

.color-mmt {
  background-color: $colorMMT;
  color: #fff;
}

.bg-barra-menu {
  background-color: #2a89b3;
}

.bg-naranja {
  background-color: $naranjaMMT;
}

.tarj {
  min-width: 19rem;
  margin-bottom: 2rem !important;
}

.etiq {
  color: #888;
  font-weight: bold;
}

.tituloTarjeta {
  font-weight: bold;
  font-size: 1.3rem;
  font-family: Arial, Helvetica, sans-serif;
}

/**
evita el pull-to-refresh en android
body {
  overscroll-behavior-y: contain;
}
*/
</style>
